import {useState} from 'react';
import useCampaignSocketConnection from './campaignSocket/useCampaignSocketConnection';
import useCampaignLiveUpdates from './useCampaignLiveUpdates';

/**
 * Minimal socket layer for Campaign Chat — consumes only campaign_live_update.
 * Legacy events (campaign_state_update, agent_art_*, campaign_processed) remain
 * available for ChatSocketPage via backend dual emit.
 */
export default function useCampaignSocket(userAccountId, activeSessionId) {
  const [connectionStatus, setConnectionStatus] = useState('disconnected');

  const {liveOverlay, handleLiveUpdate, resetLiveOverlay} =
    useCampaignLiveUpdates(activeSessionId);

  const registerHandlers = (socket, isCancelled) => {
    const onCampaignLiveUpdate = (data) => {
      if (isCancelled()) {
        return;
      }

      handleLiveUpdate({event: data});
      window.dispatchEvent(new CustomEvent('campaign_state_update_local', {detail: data}));
    };

    const onArtCreditsUpdated = () => {
      if (isCancelled()) {
        return;
      }

      window.dispatchEvent(new CustomEvent('user-plan-count-updated'));
    };

    socket.on('campaign_live_update', onCampaignLiveUpdate);
    socket.on('art_credits_updated', onArtCreditsUpdated);

    return () => {
      socket.off('campaign_live_update', onCampaignLiveUpdate);
      socket.off('art_credits_updated', onArtCreditsUpdated);
    };
  };



  useCampaignSocketConnection({
    userAccountId,
    onConnect: () => setConnectionStatus('connected'),
    onDisconnect: () => setConnectionStatus('disconnected'),
    onConnectError: (error) => {
      console.error(
        '[useCampaignSocket] socket connection error:',
        error?.message || error,
      );
      setConnectionStatus('error');
    },
    registerHandlers,
  });

  return {
    connectionStatus,
    liveOverlay,
    resetCampaignRuntime: resetLiveOverlay,
  };
}
